export type Conditions = Array<(paramKey: string) => boolean>;

/**
 * condition을 만족하는 search parameter key에 대해 해당하는 value를 교체합니다.
 */
const replaceSearchParam = (url: string, conditions: Conditions, replacer: string) => {
  const targetUrl = new URL(url);

  targetUrl.searchParams.forEach((_, paramKey) => {
    conditions.forEach((condition) => {
      if (condition(paramKey)) {
        targetUrl.searchParams.set(paramKey, replacer);
      }
    });
  });

  return targetUrl.href;
};

export default replaceSearchParam;
